import classNames from "classnames";
import { ChangeEventHandler } from "react";

interface SelectProps {
  id?: string;
  row?: boolean;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

function Select({
  id = undefined,
  row = false,
  checked,
  onChange,
}: SelectProps) {
  return (
    <label className="relative block w-5 h-5 hover:cursor-pointer">
      <input
        id={id}
        type="checkbox"
        className="peer absolute opacity-0 h-0 w-0 cursor-pointer"
        onChange={onChange}
        checked={checked}
      />
      <span
        className={classNames(
          "absolute w-5 h-5 bg-white top-0 left-0 rounded",
          "after:content-[''] after:hidden after:absolute",
          "after:left-[5px] after:top-[1px] after:w-2 after:h-3 after:border-primary-600 after:rotate-45",
          "after:border-t-0 after:border-r-2 after:border-b-2 after:border-l-0 after:border-white",
          "peer-checked:bg-primary-300 peer-checked:after:block",
          {
            "border border-primary-200 peer-checked:border-transparent": row,
          },
        )}
      />
    </label>
  );
}

export default Select;
